import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { getTimestampToDate, sleep } from "../../../common/util";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { POPUP_TYPE } from "../../../value/type";


import { DetailProps } from "../../../interfaceTypes/ContentsProps";
import { HostClusterTableData, initRouterDetailData, tableHeaders } from "./RouterDetailData";
import { useTranslation } from "react-i18next";
import { PopupModalItemType } from "../../base/modal/PopupModal";
import RouterDetail from "./RouterDetail";
import { RouterDetailData, actionMenusDetail, routerNetworkPortAddModalContent, routerUpdateModalContent } from "./RouterData";




export default function SecurityGroupDetailContainter(props:DetailProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const [targetId, setTargetId] = useState(props.targetId || '');

    const [refreshYn, setRefreshYn] = useState(false);
    const [loadSecurityGroupYn, setLoadSecurityGroupYn] = useState(false);

    const fetchIdRef = useRef(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [selectItems, setSelectItems] = useState([]);

    const [detailData, setDetailData] = useState<RouterDetailData>(initRouterDetailData);
    const [tableData, setTableData] = useState<HostClusterTableData[]>([]);

    const [executeDeleteNetworkPortYn, setExecuteDeleteNetworkPortYn] = useState(false);
    const [actionResultTitle, setActionResultTitle] = useState("");
    const [actionResultMessage, setActionResultMessage] = useState("");
    const [actionResults, setActionResults] = useState<PopupModalItemType[]>([]);
    const [actionResultCount, setActionResultCount] = useState(0);

    const headers = useMemo(() => tableHeaders, []);
    const navigate = useNavigate();

    useEffect(() => {
        props.setLoading(false);
        AlertFunction('');
    }, []);

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    useEffect(() => {
        if(!targetId) {
            const localTargetId = sessionStorage.getItem(SESSIONSTORAGE.ROUTER_TARGET_ID);
            if(localTargetId) {
                setTargetId(localTargetId);
            } else {
                navigate(`${PAGE_URL.ERRORPAGE}`);
            }
        } else {
            sessionStorage.setItem(SESSIONSTORAGE.ROUTER_TARGET_ID, targetId);
        }
    }, [props]);

    useEffect(() => {
        if(targetId) {
            executeLoadRouter();
        }
    }, [targetId]);

    useEffect(() => {
        if(targetId && refreshYn) {
            executeLoadRouter();
        }
    }, [refreshYn]);


    useEffect(() => {
        if(actionResults.length === 0) {
            return ;
        }
        if(actionResultMessage && actionResultTitle) {
            const items = actionResults.map((item) => {
                return { target: item.target, successYn: item.successYn, reason: item.reason}
            });
            const completeYn = items.length === selectItems.length ? true : false;
            props.showPopupModalCb({
                openYn: true,
                type: POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP,
                title: actionResultTitle,
                message: actionResultMessage,
                items: items,
                completeTargetText: t("ROUTER_NAME_TEXT"),
                code: "COMPLETE",
                cancelButtonYn: false,
                confirmButtonCb: confirmAction,
                completeYn: completeYn
            });

            if(completeYn) {
                props.setLoading(false);
            }
        }
        if(actionResults.length > 0) {
            setActionResultCount(actionResultCount - 1);
        }
    }, [actionResults, actionResultTitle, actionResultMessage]);

    useEffect(() => {
        if(actionResultCount === selectItems.length) {
            props.setLoading(true);
        }
        if(actionResultCount > 0) {
            if(executeDeleteNetworkPortYn) {
                setActionResultTitle(t("ROUTER_NETWORK_PORT_DELETE_COMPLETE_TEXT"));
                setActionResultMessage(t("MESSAGE_ROUTER_NETWORK_PORT_DELETE_COMPLETE_MESSAGE"));
                executeDeleteNetworkPort(selectItems[selectItems.length - actionResultCount]);
            }
        }
    }, [actionResultCount, executeDeleteNetworkPortYn]);

    function executeResult(target, successYn, reason:string="") {
        const results = actionResults.concat([{target: target, successYn: successYn, reason:reason }]);
        setActionResults(results);
    }

    function executeDeleteNetworkPort(item) {
        if(!item.device_owner || item.router_external_gateway_yn || item.device_owner.indexOf('router_ha_interface') >= 0) {
            executeResult(item.network_port_name, false, t("MESSAGE_ROUTER_PORT_DELETE_CANNOT_IN_LIST_MESSAGE"));
            return
        }
        requests.delete(PLATFORM_URL.ROUTER + "/" + targetId + '/networkports/' + item.network_port_id)
        .then(() => {
            executeResult(item.network_port_name, true);
        })
        .catch(() => {
            executeResult(item.network_port_name, false, t("MESSAGE_ROUTER_PORT_DELETE_CANNOT_IN_LIST_MESSAGE"));
        })
    }

    function executeLoadRouter() {
        props.setLoading(true);
        requests.get(PLATFORM_URL.ROUTER + "/" + targetId)
        .then((response) => {
            //set data
            if (response.status === 200 && response.data) {
                setDetailData(response.data);
                setTableData(response.data.network_ports)
                setTotalItemCount(response.data.network_ports.length)
                setPageCount(parseInt((response.data.network_ports.length/20).toFixed()) + 1)
            }
            props.setLoading(false);
            setRefreshYn(false);
        })
        .catch(() => {
            //show error message
            setLoadSecurityGroupYn(true);
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            setRefreshYn(false);
        });
    }


    function addRoueterNetworkPortResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_SECURITY_GROUP_RULE_ADD_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }

    function confirmAction(code) {
        if(code === "NETWORK_PORT_DELETE") {
            setActionResultCount(selectItems.length);
            setExecuteDeleteNetworkPortYn(true);
        } else if(code !== "COMPLETE") {
            setActionResultCount(selectItems.length);
        } else {
            setActionResultCount(0);
            setActionResults([]);
            setActionResultMessage("");
            setActionResultTitle("");
            setExecuteDeleteNetworkPortYn(false);
            setRefreshYn(true);
            AlertFunction('');
        }
    }


    function clickActionMenu(code) {
        if(code === "NETWORK_PORT_ADD") {
            if(props.showSlideModalCb) {
                props.showSlideModalCb({...routerNetworkPortAddModalContent, openYn: true, resultCb: addRoueterNetworkPortResult, args: {routerId: targetId, networkId: detailData.network.network_id}});
            }
        } else if(code === "NETWORK_PORT_DELETE") {
            props.showPopupModalCb({openYn: true,
                                    type: POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP,
                                    title: t("MESSAGE_ROUTER_NETWORK_PORT_DELETE_REQUEST_TITLE_MESSAGE"),
                                    message: t("MESSAGE_ROUTER_NETWORK_PORT_DELETE_REQUEST_MESSAGE"),
                                    items: selectItems.map((item: any) => {
                                            return { target: item.network_port_id }
                                    }),
                                    code: "NETWORK_PORT_DELETE",
                                    cancelButtonYn: true,
                                    confirmButtonCb: confirmAction,

            });
        } else if(code === "NETWORK_PORT_SYNC") {
            props.setLoading(true)
            requests.post(PLATFORM_URL.ROUTER + "/" + targetId + "/networkports" + PLATFORM_URL.SYNC, {})
            .then(async (response) => {
                if (response.status === 200) {
                    AlertFunction(t("SYNC_COMPLETED_TEXT"));
                    setRefreshYn(true);
                }
            })
        }
    }


    function selectRow(items) {
        // !!선택 테이블인 경우 액션 메뉴 상태 변경 커스텀
        setSelectItems(items);

        if(items.length > 0) {
            setActionMenuStatus(2, true);

        } else {
            setActionMenuStatus(2, false);
        }
    }

    function setActionMenuStatus(id, activeYn) {
        actionMenusDetail[id - 1].activeYn = activeYn;
    }

    function updateRouterResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_ROUTER_UPDATE_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }

    function clickUpdate() {
        const data = {
            routerId: targetId,
            routerName: detailData.router_name,
            routerDesc: detailData.router_description,
            routerUpYn: detailData.up_yn
        }
        if(props.showSlideModalCb) {
            props.showSlideModalCb({...routerUpdateModalContent, openYn: true, resultCb: updateRouterResult, args: data});
        }
    }

    return (
        <RouterDetail
            detailData={detailData}
            infoText={infoText}
            infoError={infoError}
            clickActionMenu={clickActionMenu}
            selectRow={selectRow}
            updateFunction={clickUpdate}
            pageCount={pageCount}
            headers={headers}
            tableData={tableData}
            totalItemCount={totalItemCount}
            refreshYn={refreshYn}
            loadMainDataYn={loadSecurityGroupYn}
        />
    );
}
